// ============================================================
// ANSICHTSSACHE-AGENT – Ein Feld vor der Anmeldung
// ============================================================
// Label, Eingabe und der Rahmen darum gehoeren zusammen —
// getrennt geschrieben laufen sie frueher oder spaeter
// auseinander. Anmeldung und Einladung teilen sich deshalb
// dieselbe Fassung.
// ============================================================

export function Feld({
  label,
  children,
  htmlFor,
}: {
  label: string;
  htmlFor: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-2">
      <label htmlFor={htmlFor} className="text-body-sm text-text-secondary block font-medium">
        {label}
      </label>
      {children}
    </div>
  );
}

/* Eine Zeile, die an mehreren Feldern haengt — deshalb einmal
   als Konstante statt jedes Mal als langer Klassenstrang.
   Der Fokus laeuft ueber `ring`, nicht ueber `border`: ein
   Rahmenwechsel verschiebt das Feld um einen Pixel, ein Ring
   legt sich darueber. */
export const FELD =
  "h-11 w-full rounded-lg border border-border bg-bg-primary/60 px-3.5 text-body-md text-text-primary " +
  "placeholder:text-text-tertiary transition-shadow duration-fast ease-standard " +
  "focus:outline-none focus:ring-2 focus:ring-accent/70 focus:border-accent/40 " +
  "disabled:cursor-not-allowed disabled:opacity-50";
